import React, { Component } from 'react'

export default class OddsBars extends Component {
  render() {
    let gridTemplateColumnsPercentage = String(this.props.teamOneData * 100) + "%" + String(this.props.teamTwoData * 100) + "%";
    return (
      
         <div className="graph-lines">
                <div style={{ display: 'grid', gridTemplateColumns: gridTemplateColumnsPercentage, height: '7px' }}>
                    <div style={{ background: this.props.teamOneColor }} ></div>
                    <div style={{ background: this.props.teamTwoColor }} ></div>
                </div>
            </div>
     
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/oddsComponents/OddsBars.js